import AkoBonusIcon from 'assets/images/AkoBonusIcon.svg?react';
import cn from 'classnames';
import { t } from 'i18next';
import { FC, useEffect, useState } from 'react';
import { PlaceBet } from 'shared/interface';
import './styles.scss';

interface Props {
	minAkoOdds: PlaceBet[];
	akoBonusPercent: number;
}

const CouponCounter: FC<Props> = ({ minAkoOdds, akoBonusPercent }) => {
	const filledBarsCount = minAkoOdds ? Math.min(5, minAkoOdds.length) : 0;
	const [previousPercent, setPreviousPercent] = useState(10);
	const [showBackgroundChange, setShowBackgroundChange] = useState(false);
	const [progressBar, setDisplayProgressBar] = useState(true);
	const akoLength = minAkoOdds.length >= 5;

	useEffect(() => {
		if (akoBonusPercent > 10 && akoBonusPercent > previousPercent) {
			setShowBackgroundChange(true);
			const timeout = setTimeout(() => {
				setShowBackgroundChange(false);
			}, 400);

			return () => clearTimeout(timeout);
		} else {
			setShowBackgroundChange(false);
		}

		setPreviousPercent(akoBonusPercent);
	}, [akoBonusPercent, previousPercent]);

	useEffect(() => {
		if (akoLength) {
			setDisplayProgressBar(true);
			const timeout = setTimeout(() => {
				setDisplayProgressBar(false);
			}, 300);
			return () => clearTimeout(timeout);
		} else {
			setDisplayProgressBar(true);
		}
	}, [akoLength]);

	return (
		<div className="CouponCounter">
			<div className={cn('CouponCounter__counterInfo', { CouponCounter__slideupAnimation: filledBarsCount === 5 })}>
				{progressBar && (
					<>
						{[...Array(5)].map((_, index) => (
							<div key={index} className={cn('CouponCounter__bar', { 'CouponCounter__bar--filled': index < filledBarsCount })} />
						))}
						<AkoBonusIcon className="couponCounter__akoBonusIcon" />
					</>
				)}
			</div>

			{minAkoOdds.length >= 5 && !progressBar && (
				<div className="CouponCounter__akoInfoSection">
					<div className={cn('CouponCounter__akoPercentInfo', { CouponCounter__akoPercentChange: showBackgroundChange })}>
						<AkoBonusIcon className={cn('CouponCounter__icon', { CouponCounter__akoPercentChangeIcon: showBackgroundChange })} />
						<p className="CouponCounter__text">{t('akoBooster')}</p>
						<span>{`${akoBonusPercent}%`}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default CouponCounter;
